module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Email Settings\n    ")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-4"
  }, [_c('v-form', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.adminUsers,
      "label": "Request Email Receivers",
      "item-avatar": "avatar",
      "item-text": "fullName",
      "item-value": "uid",
      "multiple": "",
      "autocomplete": "",
      "deletable-chips": "",
      "clearable": "",
      "chips": ""
    },
    model: {
      value: (_vm.requestEmailReceivers),
      callback: function($$v) {
        _vm.requestEmailReceivers = $$v
      },
      expression: "requestEmailReceivers"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.adminUsers,
      "label": "Company Submission Email Receivers",
      "item-avatar": "avatar",
      "item-text": "fullName",
      "item-value": "uid",
      "multiple": "",
      "autocomplete": "",
      "deletable-chips": "",
      "clearable": "",
      "chips": ""
    },
    model: {
      value: (_vm.companySubmissionEmailReceivers),
      callback: function($$v) {
        _vm.companySubmissionEmailReceivers = $$v
      },
      expression: "companySubmissionEmailReceivers"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "disabled": _vm.saving,
      "loading": _vm.saving,
      "color": "primary"
    },
    on: {
      "click": _vm.saveEmailReceivers
    }
  }, [_vm._v("\n            Save\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b7ee0b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Pages/email-settings.vue
// module id = 1705
// module chunks = 2